export const deliverySettings = {
	title: "Delivery integrations",
	description:
		"Integrate with a partner Delivery platform and centralize your management in Zig.",
	integrateButton: "New integration",
	configPage: {
		title: "Delivery settings",
		description: "Manage your delivery menu and store settings.",
	},
	tabs: {
		management: "Integration management",
		integrate: "Integrate delivery",
		configuration: "Settings",
	},
	newIntegration: {
		modal: {
			title: "New integration",
			description:
				"Select the system you want to continue with the delivery integration.",
			cancelButton: "Cancel",
			selectButton: "Select platform",
		},
		drawer: {
			title: "New Integration",
			importantTitle: "Important!",
			importantDescription:
				"You are about to integrate the {{system}} system with Zig, so the menu can be imported and products synced.",
			cancelButton: "Cancel",
			nextButton: "Next",
		},
	},
	integrate: {
		steps: {
			systemLabel: "Select integration system",
			authLabel: "Authenticate integration",
			syncMenuLabel: "Sync menu",
			systemAndAuth: {
				titleSystemIntegration: "Integration system",
				titleAuth: "Authenticate with partner system",
				descriptionIFood: "Paste your API key provided by IFood.",
				descriptionAuthRappi: "Paste your API key provided by Rappi.",
				descriptionKeeta: "Click 'Authorize integration' to connect with Keeta.",
				descriptionFood99: "Click 'Authorize integration' to connect with 99Food.",
				labelSelect: "Select who you want to integrate with",
				labelInput: "Store ID",
				labelCNPJ: "Store CNPJ",
				errorCNPJRequired: "CNPJ is required",
				placeholderInputIFood: "Paste the code copied from iFood",
				placeholderInputRappi: "Paste the code copied from Rappi",
				placeholderInput: "Paste the code here",
				placeholderCNPJ: "Enter the CNPJ",
				submitButton: "Continue with integration",
				authorizeButton: "Authorize integration",
				buttonAddMore: "Add another store",
				avisoTitle: "We need authorization to integrate with Rappi",
				avisoDescription:
					"Send a request to our support team and we will get in touch to follow up with the integration process.",
				iFoodDialog: {
					title: "We need authorization to integrate",
					description:
						"To continue with the integration with iFood, your confirmation is required. To do this, you must access the system and generate an API key. When you copy the iFood key, return to continue with the integration.",
					cancelButton: "Cancel integration",
					openButton: "Open iFood",
				},
				keetaDialog: {
					title: "Authentication in partner system",
					heading: "We're almost there!",
					descriptionBefore: 'By clicking "',
					descriptionBold: "authorize integration",
					descriptionAfter:
						'", you will be directed to the Keeta platform and will confirm the authorization.',
					cancelButton: "Cancel",
					authorizeButton: "Authorize integration",
				},
				food99Dialog: {
					title: "99Food Integration",
					heading: "Enter your store ID",
					description:
						'Go to the 99Food Admin panel, navigate to "Store Information" and copy the Store ID.',
					inputPlaceholder: "Store ID (e.g. 5764615004067727796)",
					bindButton: "Bind",
					closeButton: "Close",
					notAuthorizedToggle: "Store has not authorized yet?",
					notAuthorizedDescription:
						"Generate an authorization link and send it to the merchant. After they authorize on the 99Food panel, come back here and try to bind again.",
					generateLinkButton: "Generate link",
					urlPlaceholder: "Authorization link",
					copyButton: "Copy",
					urlCopied: "Link copied!",
					urlCopyFailed: "Failed to copy",
				},
			},
			syncMenu: {
				title: "Soon you will be able to import your menu!",
				descriptionIFood:
					"In a few weeks you will be able to import your menu from iFood and use it also in our system.",
				descriptionRappi:
					"In a few weeks you will be able to import your menu from Rappi and use it also in our system.",
				syncOffMenuButton: "Finish integration without menu",
				syncPending: {
					title: "Bring your menu to Zig",
					description:
						"Associate your menu from {{externalStoreType}} with the products registered on Zig and have a centralized management.",
					syncMenuButton: "Sync menu from {{externalStoreType}}",
					syncLate: "Sync later",
				},
				importPending: {
					title: "Bring your menu to Zig",
					description:
						"You can import your menu from {{externalStoreType}} and use it also in our system.",
					syncMenuButton: "Import menu from {{externalStoreType}}",
					completeWithoutMenu: "Finish integration without menu",
				},
			},
		},
	},
	management: {
		newMerchantTitle: "Add new store",
		newMerchantButton: "Add store",
		labelInput: "Store ID",
		integrationDescription: "API integration",
		integrationDescriptionWithDate: "API integration - {{date}}",
		removeIntegration: "Remove integration",
		saveChanges: "Save changes",
		backToImport: "Back to Import",
		syncMenu: "Continue Sync",
		validateAndLink: "Validate and Link",
		merchants: "Stores",
		active: "Active",
		activeIntegration: "Activate integration",
		disableIntegration: "Deactivate integration",
		integrationSuccess: "Integration updated successfully",
		integrationError: "Error updating integration. Please try again.",
		awaitIntegration: "Waiting for integration",
		removeIntegrationModal: {
			button: "Remove integration",
			title: "Remove integration",
			description: "Are you sure you want to remove the integrations?",
			okText: "Confirm",
			cancelText: "Cancel",
		},
		emptyState: {
			title: "There's nothing here yet",
			description: "It looks like you don't have a delivery integrated yet.",
			button: "Integrate a Delivery",
		},
	},
	coalaConfig: {
		emptyState: {
			title: "There's nothing here yet",
			description: "It looks like you don't have a menu to configure.",
			button: "Integrate a Delivery",
		},
	},
};
